class SvcsScreenMeal {
    classes = {
        active_segment_class : 'is-active',
        active_category_class: 'is-active',
        hidden_category_class: 'hidden'
    };
    selectors = {
        category              : '.js-svc-meal-category',
        tab_segment           : '.js-tab-meal-segment',
        side_total_segment    : '.js-side-total-segment',
        side_total_item       : '.js-side-total-item',
        side_total_item_count : '.js-side-total-item-count',
        side_total_item_amount: '.js-side-total-item-amount',
        side_total_item_remove: '.js-side-total-item-remove',
        side_warning_segment  : '.js-segment-wrapper'
    };

    constructor($wrapper, options) {
        const that = this;

        // DOM
        that.$wrapper = $wrapper;

        that.$categories_section         = that.$wrapper.find('.js-pills-wrapper');
        that.$categories_wrapper         = that.$categories_section.find('.js-svc-meal-categories');
        that.$categories                 = that.$categories_wrapper.find(that.selectors.category);
        that.$categories_toggle          = that.$categories_wrapper.find('.js-categories-toggle')
        that.$selected_categories_toggle = that.$categories_wrapper.find('.js-selected-categories-toggle');
        that.$segments_wrapper           = that.$wrapper.find('.js-tabs-meal-segments');
        that.$meal_items                 = that.$wrapper.find('.js-svc-card-wrapper');

        // CONST
        that.modals                         = options['modals'];
        that.locales                        = options['locales'];
        that.order_currency                 = options['order_currency'];
        that.analytics_dataset              = options['analytics_dataset'];
        that.order_segments_ids             = options['order_segments_ids'];
        that.order_passengers_ids           = options['order_passengers_ids'];
        that.meal_incomplete_warning_enable = options['meal_incomplete_warning_enable'];

        // MODEL
        that.order_segments      = getOrderSegments(options.order_segments);
        that.meal_svcs           = getMealSvcs(options.meal_svcs);
        that.meal_prices_grouped = getMealPricesGrouped(options.meal_prices);
        that.meal_segments       = that.#getMealSegments(that.order_segments, that.meal_svcs, that.meal_prices_grouped);

        // VARS
        that.meal_items_unpaid  = options['meal_items_unpaid'] || [];
        that.meal_items_paid    = options['meal_items_paid'] || [];
        that.meal_items_default = options['meal_items_default'] || [];

        that.active_segment_id = that.#getActiveSegmentId();

        that.meal_items         = that.#initMealItems(that.$meal_items);
        that.side_widget        = that.#initSideWidget(that.meal_items);
        that.categories_section = that.#initCategoriesSection();

        // FUNCTIONS
        /**
         * @type {Function}
         * */
        that.onSvcSelected = (options['onSvcSelected'] || function () {});
        /**
         * @type {Function}
         * */
        that.onSvcReset = (options['onSvcReset'] || function () {});

        that.init();

        $.sa.log(that);

        // Functions

        /**
         * @param {Object|Array} order_segments
         * @return {Object}
         * */
        function getOrderSegments(order_segments) {
            return (Array.isArray(order_segments) ? {} : order_segments);
        }

        /**
         * @param {Object|Array} meal_svcs
         * @return {Object}
         * */
        function getMealSvcs(meal_svcs) {
            meal_svcs = (Array.isArray(meal_svcs) ? {} : meal_svcs);

            // String to Number
            Object.values(meal_svcs).forEach( function(svc) {
                svc.max_quantity = svc.max_quantity * 1;
            });

            return meal_svcs;
        }
        
        /**
         * @param {Array} meal_prices
         * @return {Object}
         * */
        function getMealPricesGrouped(meal_prices) {
            const meal_prices_grouped = $.sa.utils.groupBy(meal_prices, 'order_segment_id');

            // String to Number
            Object.values(meal_prices_grouped).forEach( function(prices) {
                prices.forEach( function(price) {
                    price.total = price.total * 1;
                });
            });

            return meal_prices_grouped;
        }
    }

    init() {
        const that = this;

        that.#initSegmentTabs();
    };

    onShow() {
        const that = this;

        that.categories_section.resize();
    }

    isValid() {
        const that = this;
        let result = true;

        const empty_segments = that.#getEmptySegments(),
              empty_count = empty_segments.length,
              segments_count = Object.keys(that.meal_segments).length;

        if (that.meal_incomplete_warning_enable
            && empty_count > 0
            && empty_count < segments_count)
        {
            result = false;
        }

        return result;
    }

    /**
     * @return {Promise}
     * */
    showWarningModal() {
        const that = this;

        return new Promise( function(resolve, reject) {
            let is_success = false;

            $.uiModal({
                html: that.modals['meal_incomplete_warning_html'],
                onButtonCancelClick: function () {
                    is_success = true;
                    that.meal_incomplete_warning_enable = false;
                },
                onClose: function() {
                    (is_success ? resolve() : reject());
                }
            });
        });
    }

    /**
     * @param {Object} item_data
     * @param {SvcsScreenMealItem} meal_item
     * */
    update(item_data, meal_item) {
        const that = this;

        // Ищем в модели раздела ранее добавленный item_data
        const search = that.meal_items_unpaid.filter( function(item) {
            return (
                item.item_id === item_data.item_id &&
                item.segment_id === item_data.segment_id &&
                item.passenger_id === item_data.passenger_id);
        });

        // Добавляем/Обновляем/Удаляем
        const item = (search.length ? search[0] : null);
        if (item) {
            const index = that.meal_items_unpaid.indexOf(item);
            if (item_data.item_quantity === 0) {
                that.meal_items_unpaid.splice(index, 1);
            } else {
                that.meal_items_unpaid.splice(index, 1, item_data);
            }
        } else {
            that.meal_items_unpaid.push(item_data);
        }

        // Проброс данных в модель раздела «Услуги»
        that.onSvcSelected(item_data);

        // Обновляем счетчик в категории "Выбрано"
        that.categories_section.update();

        // Обновляем боковой виджет
        that.side_widget.updateMealItem(meal_item);
    }

    #initMealItems($meal_items) {
        const that = this;

        const result = [];

        $.each($meal_items, function() {
            const $meal_item = $(this);

            const item_id = $meal_item.data('airline-svc-id') + '',
                  segment_id = $meal_item.data('segment-id') + '';

            const meal_item = new SvcsScreenMealItem($meal_item, {
                item_id: item_id,
                segment_id: segment_id,
                meal_segment: that.meal_segments[segment_id],
                passengers: getPassengers(item_id, segment_id),
                modal_html: that.modals['meal_item'],
                onChange: function(data, meal_item) {
                    // Обновляем модель данных в текущем разделе
                    that.update(data, meal_item);
                }
            });
            result.push(meal_item);
        });

        return result;

        /**
         * @description Получаем модель данных товара по пассажирам 
         * @param {String} item_id
         * @param {String} segment_id
         * @return {Object}
         * */
        function getPassengers(item_id, segment_id) {
            let passengers = {};

            // Создаем модель данных пассажиров
            $.each(that.order_passengers_ids, function(i, passenger_id) {
                passengers[passenger_id] = {
                    id: passenger_id,
                    quantity: 0
                }
            });

            // Ищем в данных с сервера добавленные продукты
            const search = that.meal_items_unpaid.filter( function(item) {
                return (
                    item.item_id === item_id &&
                    item.segment_id === segment_id);
            });

            // Добавляем в модель
            search.forEach( function(item) {
                if (passengers[item.passenger_id] && item.item_quantity > 0) {
                    passengers[item.passenger_id].quantity = parseFloat(item.item_quantity)
                }
            });

            return passengers;
        }
    }

    #initSideWidget(meal_items) {
        const that = this;

        const $total_widget = that.$wrapper.find('.js-svcs-meal-total-widget'),
              $content = $total_widget.find('.js-svcs-other-total-content'),
              $warning_widget = that.$wrapper.find('.js-svcs-meal-warning-widget');

        //

        meal_items.forEach( meal_item => updateMealItem(meal_item) );

        //

        $total_widget.on('click', '.js-other-total-call', function(event) {
            event.preventDefault();

            $.uiDrawer({
                position: 'bottom',
                header_title: $(this).data('title'),
                content: $content.html(),
                custom_class: 'svcs-other svcs-meal',
                fluid: true,
                disable_content_scroll: true,
                onOpen: function($drawer) {

                    $drawer.on('click', that.selectors.side_total_item_remove, function(event) {
                        event.preventDefault();
                        const $target = $(this);
                        onItemRemove($target);
                        $target.closest(that.selectors.side_total_item).hide();
                    });
                }
            });
        });

        $total_widget.on('click', that.selectors.side_total_item_remove, function(event) {
            event.preventDefault();
            onItemRemove($(this));
        });

        if ($warning_widget.length) {
            $warning_widget.on('click', '.js-add-meal-to-segment', function() {
                const segment_id = $(this).data('segment-id') + '';
                that.$wrapper.find('.js-tab-heading[data-tab-for="segment-'+ segment_id +'"]').trigger('click');
            });
        }

        //

        return {
            update: function() {
                meal_items.forEach( meal_item => updateMealItem(meal_item) );
            },
            updateMealItem: updateMealItem
        }

        //

        function onItemRemove($target) {
            const $meal_item = $target.closest(that.selectors.side_total_item),
                  $segment = $meal_item.closest(that.selectors.side_total_segment);

            const meal_item_id = $meal_item.data('id') + '',
                  segment_id = $segment.data('segment-id') + '';

            removeMealItem(meal_item_id, segment_id);
        }

        function updateMealItem(meal_item) {
            const $total_segment = $total_widget.find(that.selectors.side_total_segment + '[data-segment-id=' + meal_item.segment_id + ']'),
                  $total_item    = $total_segment.find(that.selectors.side_total_item + '[data-id=' + meal_item.meal_item_id + ']');

            if (meal_item.quantity > 0) {
                const $total_item_count  = $total_item.find(that.selectors.side_total_item_count),
                      $total_item_amount = $total_item.find(that.selectors.side_total_item_amount);

                $total_item_count.text('x' + meal_item.quantity);
                $total_item_amount.html($.sa.format.price(meal_item.price * meal_item.quantity, meal_item.currency));
                $total_item.show();
            } else {
                $total_item.hide();
            }

            if ($warning_widget.length) {
                updateWarningWidget(meal_item);
            }

            function updateWarningWidget(meal_item) {
                const $warning_segment = $warning_widget.find(that.selectors.side_warning_segment + '[data-segment-id=' + meal_item.segment_id + ']');

                if (meal_item.quantity > 0 || meal_item.segment_id === that.active_segment_id) {
                    $warning_segment.hide();

                    const empty_segments = that.#getEmptySegments();
                    if (empty_segments.length === 1 && empty_segments[0].id === that.active_segment_id) {
                        empty_segments.splice(0, 1);
                    }

                    if (!empty_segments.length) {
                        $warning_widget.hide();
                    }

                } else {
                    const segment_search = that.meal_items_unpaid.filter( item => (item.segment_id === meal_item.segment_id));
                    if (segment_search.length === 0) {
                        $warning_segment.show();
                        $warning_widget.show();
                    }
                }
            }
        }
        
        function removeMealItem(meal_item_id, segment_id) {
            const meal_item_search = that.meal_items.filter( function(meal_item) {
                return (meal_item.meal_item_id === meal_item_id && meal_item.segment_id === segment_id);
            });

            if (meal_item_search.length) {
                const meal_item = meal_item_search[0];
                meal_item.removeMealItem();
            }
        }
    }

    #initCategoriesSection() {
        const that = this;

        const active_category_class = that.classes.active_category_class,
              visible_category_class = 'is-visible',
              hidden_category_class = 'is-hidden';

        let $active_category = that.$categories.filter('.' + active_category_class);

        let selected_items_count     = null,
            categories_toggle_active = false;

        //

        that.$categories_wrapper.on('click', that.selectors.category, function(event) {
            event.preventDefault();
            const $category = $(this),
                  category_id = $category.data('category-id') + '';

            setCategory($category);
            filterMealItem(category_id);
        });

        that.$selected_categories_toggle.on('click', function(event) {
            event.preventDefault();
            const $category = $(this);

            setCategory($category);
        });

        initCategoriesToggle();

        return {
            update: function() {
                updateCategories();
                checkActiveCategory();
            },
            resize: resizeCategories
        };

        //

        function checkActiveCategory() {
            if (!$active_category.length || $active_category.hasClass(hidden_category_class)) {
                const $first_category = that.$categories_wrapper.find(that.selectors.category).first(),
                      category_id = $first_category.data('category-id') + '';

                setCategory($first_category);
                filterMealItem(category_id);
            }
        }

        function initCategoriesToggle() {
            const $categories_toggle = that.$categories_toggle;

            let resize_timer = 0;

            updateCategories();
            toggleCategories();

            $categories_toggle.on('click', function(event) {
                event.preventDefault();
                toggleCategories(!categories_toggle_active);
                resizeCategories();
            });

            $.sa.$window.on('resize', function() {
                clearTimeout(resize_timer);
                resize_timer = setTimeout( function() {
                    if (that.$wrapper.is(':visible')) {
                        resizeCategories();
                    }
                }, 10);
            });

            function toggleCategories(active) {
                categories_toggle_active = (typeof active === 'boolean' ? active : categories_toggle_active);
                const toggle_text = (categories_toggle_active ? $.sa.locales['less'] : $.sa.locales['more']) + '...';
                $categories_toggle.text(toggle_text);
            }
        }

        function setCategory($category) {
            if ($active_category.length) {
                $active_category.removeClass(active_category_class);
            }

            $active_category = $category.addClass(active_category_class);
        }

        function filterMealItem(category_id) {
            that.meal_items.forEach( function(meal_item) {
                let show_meal_item = (category_id === meal_item.category_id);

                switch (category_id) {
                    case 'all':
                        show_meal_item = true;
                        break;

                    case 'selected':
                        show_meal_item = (meal_item.quantity > 0);
                        break;
                }

                meal_item.display(show_meal_item);
            });
        }

        function resizeCategories() {
            const $wrapper = that.$categories_wrapper,
                  $items = getItems(that.$categories),
                  $toggle = that.$categories_toggle;

            const wrapper_width = $wrapper.width(),
                  toggle_width = $toggle.outerWidth(),
                  toggle_place_width = toggle_width + 40;

            let gap_margin = parseInt($wrapper.css('gap'));
            gap_margin = (gap_margin > 0 ? gap_margin : 0);

            let line_space = toggle_place_width;

            // Для mobile: скрываем переключатель
            const is_mobile = $.sa.is_mobile();
            if (is_mobile) {
                $toggle.hide();
            } else {
                $toggle.show();    
            }

            // Перебираем все элементы
            $.each($items, function() {
                const $item = $(this).show(),
                      item_width = $item.outerWidth(true) + gap_margin;

                $item
                    .addClass(visible_category_class)
                    .removeClass(hidden_category_class);

                if (is_mobile) { return; }

                line_space += item_width;
                if (line_space > wrapper_width) {
                    if (!categories_toggle_active) {
                        $item
                            .removeClass(visible_category_class)
                            .addClass(hidden_category_class)
                            .hide();
                    }
                }
            });

            // Для desktop: скрывает переключатель если все влезло
            if (line_space < wrapper_width) {
                $toggle.hide();
            }

            function getItems($categories) {
                if (!selected_items_count) {
                    $categories = $categories.filter( function() {
                        const $category = $(this),
                              id = $category.data('category-id');

                        return (id !== 'selected' && !$category.hasClass(that.classes.hidden_category_class));
                    });
                }

                return $categories;
            }
        }

        function updateCategories() {
            const new_selected_items_count = Object.values(that.meal_items).reduce( function(count, meal_item) {
                return (meal_item.segment_id === that.active_segment_id && meal_item.quantity > 0 ? count + 1 : count);
            }, 0);

            if (selected_items_count !== new_selected_items_count) {
                const text = that.locales.selected.replace('%s', new_selected_items_count);
                that.$selected_categories_toggle.text(text);

                if (new_selected_items_count > 0) {
                    that.$selected_categories_toggle
                        .removeClass(hidden_category_class)
                        .addClass(visible_category_class)
                        .show();

                } else {
                    that.$selected_categories_toggle
                        .removeClass(visible_category_class)
                        .addClass(hidden_category_class)
                        .hide();
                }

                selected_items_count = new_selected_items_count;
            }

            resizeCategories();
        }
    }

    #initSegmentTabs() {
        const that = this;

        filterCategories(that.active_segment_id);

        that.side_widget.update();

        that.$segments_wrapper.on('click', that.selectors.tab_segment, function() {
            that.active_segment_id = that.#getActiveSegmentId($(this));
            filterCategories(that.active_segment_id);
            that.categories_section.update();
            that.side_widget.update();

            const $active_category = that.$categories.filter( function() {
                return $(this).hasClass(that.classes.active_category_class);
            });

            if ($active_category.hasClass(that.classes.hidden_category_class)) {
                that.$categories.first().trigger('click');
            }
        });

        function filterCategories(active_segment_id) {
            const segments_with_categories = getSegmentsWithCategories(),
                  segment = segments_with_categories[active_segment_id];

            let $all_category = null,
                is_empty = true;

            that.$categories_wrapper.find(that.selectors.category).each( function() {
                const $category = $(this),
                      category_id = $category.data('category-id') + '';

                if (category_id === 'all') {
                    $all_category = $category;
                }

                if (['all', 'selected'].indexOf(category_id) >= 0) { return; }

                if (segment && segment.categories[category_id]) {
                    is_empty = false;
                    $category.removeClass(that.classes.hidden_category_class);
                } else {
                    $category.addClass(that.classes.hidden_category_class);
                }
            });

            if ($all_category) {
                $all_category.attr('disabled', is_empty);
            }

            function getSegmentsWithCategories() {
                const segments = {};

                that.meal_items.forEach( function(meal_item) {
                    if (!segments[meal_item.segment_id]) {
                        segments[meal_item.segment_id] = {
                            categories: {}
                        }
                    }

                    const segment = segments[meal_item.segment_id];

                    if (!segment.categories[meal_item.category_id]) {
                        segment.categories[meal_item.category_id] = {
                            meal_items: {}
                        }
                    }

                    const category = segment.categories[meal_item.category_id];
                    category.meal_items[meal_item.meal_item_id] = meal_item;
                });

                return segments;
            }
        }
    }

    /**
     * @description Возвращает массив с пустыми сегментами (нет добавленных продуктов)
     * @return {Array}
     * */
    #getEmptySegments() {
        const that = this;

        const empty_segment_ids = that.meal_items_unpaid.reduce( function(ids, item) {
            const index = ids.indexOf(item.segment_id);
            if (index >= 0) {
                ids.splice(index, 1);
            }
            return ids;
        }, Object.keys(that.meal_segments));

        return empty_segment_ids
            .map( function(segment_id) {
                return that.meal_segments[segment_id];
            })
            .filter( function(segment) {
                return (Object.keys(segment.meal_items).length > 0)
            });
    }

    #getActiveSegmentId($segment) {
        const that = this;
        $segment = ($segment ? $segment : that.$segments_wrapper.find(that.selectors.tab_segment + "." + that.classes.active_segment_class));
        return $segment.data('segment-id') + '';
    }

    /**
     * @param {Object|Array} order_segments
     * @param {Object|Array} meal_svcs
     * @param {Object|Array} meal_prices_grouped
     * @return {Object} 
     * */
    #getMealSegments(order_segments, meal_svcs, meal_prices_grouped) {
        const that = this;
        const result = {};

        $.each(order_segments, function(i, segment) {
            const meal_segment_prices = (meal_prices_grouped[segment.id] || []),
                  meal_segment_prices_grouped = $.sa.utils.groupBy(meal_segment_prices, 'airline_svc_id'),
                  meal_items = {};

            $.each(meal_segment_prices_grouped, function(svc_id, svc_prices) {
                const airline_svc = (meal_svcs[svc_id] || null);
                if (!airline_svc) { return; }

                if (!airline_svc['allow_zero_price']) {
                    svc_prices = svc_prices.filter( price => price['total'] > 0);
                }

                const price_data = svc_prices.reduce( function(target, price) {
                    return (price.total < target.total ? price : target);
                }, svc_prices[0]);

                meal_items[airline_svc.id] = {
                    'id'          : airline_svc.id,
                    'airline_svc' : airline_svc,
                    'currency'    : price_data['currency'],
                    'price'       : price_data['total'],
                    'max_quantity': airline_svc['max_quantity']
                };
            });

            result[segment['id']] = {
                'id'        : segment['id'],
                'segment'   : segment,
                'meal_items': meal_items
            };
        });

        return result;
    }
}